import { ArrowRight, RotateCw } from 'react-feather'
import { match } from 'ts-pattern'

import { DirectTask, TrueworkJsStrategy } from '@frame/lib/api/tasks/types'

import { LoadingSpinner } from '../loading-spinner'
import { TaskVisualStatus } from './types'

export function getTextFromVisualStatus(status: TaskVisualStatus, verifierName: string) {
  return match(status)
    .with(TaskVisualStatus.NOT_ATTEMPTED_CREDENTIALS_DOCUMENTS, () => 'Connect payroll or upload documents')
    .with(TaskVisualStatus.NOT_ATTEMPTED_CREDENTIALS, () => 'Connect payroll')
    .with(TaskVisualStatus.NOT_ATTEMPTED_DOCUMENTS, () => 'Upload documents')
    .with(TaskVisualStatus.NOT_ATTEMPTED_BANK, () => 'Click to start')
    .with(TaskVisualStatus.NOT_ATTEMPTED_IRS, () => 'Authorize access')
    .with(TaskVisualStatus.COMPLETED_CREDENTIALS, () => 'Successfully connected payroll')
    .with(TaskVisualStatus.COMPLETED_DOCUMENTS, () => 'Successfully uploaded documents')
    .with(TaskVisualStatus.COMPLETED_IRS, () => 'Authorized')
    .with(TaskVisualStatus.COMPLETED_INSTANT, () => 'Verified by Truework')
    .with(TaskVisualStatus.COMPLETED_BANK, () => 'Connected')
    .with(TaskVisualStatus.SKIPPED_BANK_IDENTIFY_INCOMES, () => 'Connected')
    .with(TaskVisualStatus.IN_PROGRESS, () => 'Verification in progress')
    .with(TaskVisualStatus.ERROR, () => `${verifierName} will review issue`)
    .with(TaskVisualStatus.SKIPPED, () => 'Attempted to verify')
    .with(TaskVisualStatus.SKIPPED_BANK_FINICITY, () => 'Attempted to link')
    .exhaustive()
}

export function getStatusIsHoverable(status: TaskVisualStatus) {
  return match(status)
    .with(TaskVisualStatus.NOT_ATTEMPTED_CREDENTIALS, () => true)
    .with(TaskVisualStatus.NOT_ATTEMPTED_DOCUMENTS, () => true)
    .with(TaskVisualStatus.NOT_ATTEMPTED_CREDENTIALS_DOCUMENTS, () => true)
    .with(TaskVisualStatus.NOT_ATTEMPTED_BANK, () => true)
    .with(TaskVisualStatus.NOT_ATTEMPTED_IRS, () => true)
    .with(TaskVisualStatus.ERROR, () => true)
    .with(TaskVisualStatus.SKIPPED, () => true)
    .with(TaskVisualStatus.SKIPPED_BANK_FINICITY, () => true)
    .otherwise(() => false)
}

export function getButtonIcon(status: TaskVisualStatus, isLoading: boolean) {
  if (isLoading) return LoadingSpinner

  return match(status)
    .with(TaskVisualStatus.NOT_ATTEMPTED_CREDENTIALS_DOCUMENTS, () => ArrowRight)
    .with(TaskVisualStatus.NOT_ATTEMPTED_CREDENTIALS, () => ArrowRight)
    .with(TaskVisualStatus.NOT_ATTEMPTED_DOCUMENTS, () => ArrowRight)
    .with(TaskVisualStatus.NOT_ATTEMPTED_BANK, () => ArrowRight)
    .with(TaskVisualStatus.NOT_ATTEMPTED_IRS, () => ArrowRight)
    .with(TaskVisualStatus.ERROR, () => RotateCw)
    .with(TaskVisualStatus.SKIPPED, () => RotateCw)
    .with(TaskVisualStatus.SKIPPED_BANK_FINICITY, () => RotateCw)
    .with(TaskVisualStatus.COMPLETED_INSTANT, () => undefined)
    .with(TaskVisualStatus.COMPLETED_CREDENTIALS, () => undefined)
    .with(TaskVisualStatus.COMPLETED_DOCUMENTS, () => undefined)
    .with(TaskVisualStatus.COMPLETED_BANK, () => undefined)
    .with(TaskVisualStatus.SKIPPED_BANK_IDENTIFY_INCOMES, () => undefined)
    .with(TaskVisualStatus.COMPLETED_IRS, () => undefined)
    .with(TaskVisualStatus.IN_PROGRESS, () => undefined)
    .exhaustive()
}

export function getStatusCanRetry(status: TaskVisualStatus) {
  return match(status)
    .with(TaskVisualStatus.ERROR, () => true)
    .with(TaskVisualStatus.SKIPPED, () => true)
    .with(TaskVisualStatus.SKIPPED_BANK_FINICITY, () => true)
    .otherwise(() => false)
}

export function isStatusSuccessful(status: TaskVisualStatus) {
  return match(status)
    .with(TaskVisualStatus.COMPLETED_CREDENTIALS, () => true)
    .with(TaskVisualStatus.COMPLETED_DOCUMENTS, () => true)
    .with(TaskVisualStatus.COMPLETED_INSTANT, () => true)
    .with(TaskVisualStatus.COMPLETED_BANK, () => true)
    .with(TaskVisualStatus.SKIPPED_BANK_IDENTIFY_INCOMES, () => true)
    .with(TaskVisualStatus.COMPLETED_IRS, () => true)
    .with(TaskVisualStatus.IN_PROGRESS, () => true)
    .otherwise(() => false)
}

export function isStatusFailure(status: TaskVisualStatus) {
  return match(status)
    .with(TaskVisualStatus.ERROR, () => true)
    .with(TaskVisualStatus.SKIPPED, () => true)
    .with(TaskVisualStatus.SKIPPED_BANK_FINICITY, () => true)
    .otherwise(() => false)
}

export function isNotAttempted(status: TaskVisualStatus) {
  return match(status)
    .with(TaskVisualStatus.NOT_ATTEMPTED_CREDENTIALS, () => true)
    .with(TaskVisualStatus.NOT_ATTEMPTED_DOCUMENTS, () => true)
    .with(TaskVisualStatus.NOT_ATTEMPTED_CREDENTIALS_DOCUMENTS, () => true)
    .with(TaskVisualStatus.NOT_ATTEMPTED_BANK, () => true)
    .with(TaskVisualStatus.NOT_ATTEMPTED_IRS, () => true)
    .otherwise(() => false)
}

export function getTaskCardTitle(task: DirectTask) {
  if (task.strategy === TrueworkJsStrategy.IRS) {
    return 'Link your tax data'
  }

  if (task.strategy === TrueworkJsStrategy.BANK) {
    return 'Link bank accounts'
  }

  if (task.employer_name) {
    return task.employer_name
  }
  return 'Your employer'
}
